module.exports = __webpack_public_path__ + "static/media/pendingIcon-settings.28dc18ff.svg";